export const TAAZE_MAIN_COLOR = '#FF057D';
